<template>
  <div>
    <form
      id="loginForm"
      class="white-lines-form animated fadeInLeft text-white"
      @submit.prevent="checkLoginForm"
    >
      <header class="h4 text-center mt-4 mb-3 userSelect-none">
        <span
          v-if="showRecoveryEmailInput"
          class="fs-inherit"
        >
          Recuperar Contraseña
        </span>
        <span
          v-else
          class="fs-inherit"
        >
          Inicia Sesión
        </span>
      </header>
      <div class="row mx-0">
        <div class="col-12 m-0 pt-1">
          <SelectIdentificationType
            v-model="login.identificationType.value"
            class-name="md-form my-1 md-outline outline-select"
            :validate-value="validateValue"
            :icon="true"
            @save="login.identificationType=$event"
          />
        </div>
        <div class="col-12">
          <mdb-input
            v-model="login.identification"
            :class="['my-2',
                     {'class-valid': validateValue.identification == 'valid'},
                     {'class-invalid':validateValue.identification=='invalid'}]"
            label="Identificación"
            icon="envelope"
            outline
          />
        </div>
        <div
          v-if="showRecoveryEmailInput"
          class="col-12"
        >
          <p class="font-weight-bold my-2 text-center">
            Ingresa el correo que usaste en el registro
          </p>
          <mdb-input
            v-model="recovery.email"
            type="email"
            :class="['my-0',
                     {'class-valid': validateValue.email == 'valid'},
                     {'class-invalid': validateValue.email == 'invalid'}]"
            label="Email"
            icon="envelope"
            outline
          />
          <div class="text-center">
            <a
              :href="!login.identificationType.value || !login.identification ||
                !recovery.email ? null : '#recupera-contraseña'"
            >
              <BtnLoader
                btn-color="primary"
                :btn-disabled="btnDisabled"
                btn-title="Recuperar"
                @click="forgotPassword"
              />
            </a>
          </div>
        </div>
        <div
          v-else
          class="col-12"
        >
          <mdb-input
            v-model="login.password"
            type="password"
            :class="['my-1',
                     {'class-valid': validateValue.password == 'valid'},
                     {'class-invalid': validateValue.password == 'invalid'}]"
            label="Contraseña"
            icon="key"
            outline
          />
        </div>
      </div>
      <div
        v-if="!showRecoveryEmailInput"
        class="text-center"
      >
        <div class="our-checkbox2">
          <label>
            <input
              v-model="login.keepSession"
              type="checkbox"
            >
            <span />
            Mantener sesión abierta
          </label>
        </div>
        <BtnLoader
          btn-classes="my-2"
          btn-type="submit"
          :btn-disabled="btnDisabled || loginBtnDisabled"
          btn-title="Entrar"
        />
      </div>
    </form>
    <section
      id="recupera-contraseña"
      :class="['row justify-content-around text-white',
               {'pt-1': showRecoveryEmailInput}]"
    >
      <a
        v-if="showRecoveryEmailInput"
        class="col-auto font-weight-bold my-2"
        @click="showRecoveryEmailInput = false; showCodeForm = false;
                showPasswordForm = false;"
      >
        Volver atrás
      </a>
      <a
        v-else
        class="col-auto font-weight-bold my-2"
        @click="showRecoveryEmailInput = true; showCodeForm = false;
                showPasswordForm = false;"
      >
        ¿Olvidó su contraseña?
      </a>
    </section>
    <form
      v-if="showCodeForm"
      class="white-lines-form text-white"
      @submit.prevent="recoveryCode"
    >
      <p class="pt-4 font-weight-bold text-center">
        Introduce el código de validación
      </p>
      <div class="row justify-content-around">
        <div class="col-12">
          <mdb-input
            v-model="recovery.code"
            :class="['my-0',
                     {'class-valid': validateValue.code == 'valid'},
                     {'class-invalid': validateValue.code == 'invalid'}]"
            label="Código"
            icon="clock"
            outline
          />
        </div>
        <BtnLoader
          btn-classes="col-auto my-2"
          btn-type="submit"
          :btn-disabled="btnDisabled"
          btn-title="Confirmar"
        />
      </div>
    </form>
    <form
      v-if="showPasswordForm"
      class="white-lines-form text-white"
      @submit.prevent="resetPassword"
    >
      <p class="pt-4 font-weight-bold text-center">
        Ingresa tu nueva clave
      </p>
      <div class="row justify-content-around">
        <div class="col-12">
          <mdb-input
            v-model="login.password"
            type="password"
            :class="['my-0',
                     {'class-valid': validateValue.password == 'valid'},
                     {'class-invalid': validateValue.password == 'invalid'}]"
            label="Nueva contraseña"
            icon="key"
            outline
          />
        </div>
        <div class="col-12">
          <mdb-input
            v-model="recovery.confirmPassword"
            type="password"
            :class="['my-0',
                     {'class-valid':validateValue.confirmPassword == 'valid'},
                     {'class-invalid': validateValue.confirmPassword ==
                       'invalid'}]"
            label="Confirmación"
            icon="key"
            outline
          />
        </div>
        <BtnLoader
          btn-classes="col-auto my-2"
          btn-type="submit"
          :btn-disabled="btnDisabled"
          btn-title="Guardar"
        />
      </div>
    </form>
    <AlertaMsj :alerta-msj="alertaMsj" />
  </div>
</template>
<script>
import {mdbInput} from 'mdbvue';
import AlertaMsj from '@/components/AlertaMsj.vue';
import BtnLoader from '@/components/customButtons/BtnLoader.vue';
import SelectIdentificationType
from '@/components/SelectIdentificationType.vue';
import {validateIdentification, emailSchema} from '@/utils/validations.js';
import gql from 'graphql-tag';
import forgotPasswordGql from '@/graphql/forgotPassword.gql';
import resetPasswordGql from '@/graphql/resetPassword.gql';
export default {
  name: 'FormLogin',
  components: {
    mdbInput,
    AlertaMsj,
    BtnLoader,
    SelectIdentificationType,
  },
  props: {
    loginBtnDisabled: Boolean,
    validateValue: {
      type: Object,
      default: function() {
        return false;
      },
    },
  },
  data() {
    return {
      login: {
        identificationType: {
          value: '',
        },
      },
      recovery: {},
      alertaMsj: {
        content: '',
      },
      showRecoveryEmailInput: false,
      showCodeForm: false,
      showPasswordForm: false,
      btnDisabled: this.loginBtnDisabled,
    };
  },
  methods: {
    checkLoginForm(event) {
      this.sendLogin();
    },
    sendLogin() {
      this.$emit('sendLogin', this.login);
    },
    forgotPassword() {
      if (!this.login.identificationType.value || !this.login.identification ||
        !this.recovery.email) {
        this.sendValidateValues('invalid', 'invalid', 'invalid');
        return this.alertaMsj = {
          content: 'Llene los datos de identificación y el correo',
          type: 'warning',
        };
      }
      if (!validateIdentification(this.login.identificationType,
          this.login.identification) || !this.login.identificationType.value) {
        this.sendValidateValues('invalid');
        return this.alertaMsj = {
          content: this.login.identificationType.mensaje,
          type: 'warning',
        };
      }
      if (this.showRecoveryEmailInput
        && !emailSchema.isValidSync({email: this.recovery.email})) {
        this.sendValidateValues('', '', 'invalid');
        return this.alertaMsj = {
          content: 'Correo electrónico no válido',
          type: 'warning',
        };
      }
      this.sendValidateValues('valid', 'valid', 'valid');
      this.btnDisabled = true;
      this.$apollo.mutate({
        mutation: gql`${forgotPasswordGql}`,
        variables: {
          identificationType: this.login.identificationType.value,
          identification: this.login.identification,
          email: this.recovery.email,
        },
      }).then((res) => {
        const msg = res.data.forgotPassword.msg;
        switch (msg) {
          case 'success':
            this.alertaMsj = {
              content: 'El mensaje de recuperación fue enviado.',
              type: 'success',
            };
            this.showCodeForm = true;
            break;
          case 'user_not_found':
            this.alertaMsj = {
              content: 'Usuario no existe!',
              type: 'danger',
            };
            break;
          case 'email_confirmation_required':
            this.alertaMsj = {
              content: 'Confirma que tu email sea correcto.',
              type: 'danger',
            };
            break;
          case 'mismatch':
            this.alertaMsj = {
              content: 'No coincide el email con la identificación ingresada',
              type: 'danger',
            };
            break;
          case 'message_not_sent':
            this.alertaMsj = {
              content: 'El mensaje de recuperación no pudo ser enviado!',
              type: 'danger',
            };
            break;
          default:
            this.alertaMsj = {
              content: 'Hubo algún error. Intenta más tarde.',
              type: 'danger',
            };
        }
        this.btnDisabled = false;
      }).catch((error) => {
        this.alertaMsj = {
          content: 'Hubo un error al enviar los datos.',
          type: 'danger',
        };
        this.btnDisabled = false;
      });
    },
    recoveryCode() {
      if (!this.recovery.code) {
        this.sendValidateValues('', '', '', 'invalid');
        return this.alertaMsj = {
          content: 'Coloque el código de recuperación para continuar',
          type: 'warning',
        };
      }
      this.login.password = '';
      this.showCodeForm = false;
      this.showPasswordForm = true;
    },
    resetPassword() {
      if (!this.login.identificationType.value || !this.login.identification ||
          !this.recovery.email) {
        this.sendValidateValues('invalid', 'invalid', 'invalid');
        return this.alertaMsj = {
          content: 'Llene los datos de identificación y el correo',
          type: 'warning',
        };
      }
      if (!validateIdentification(this.login.identificationType,
          this.login.identification) || !this.login.identificationType.value) {
        this.sendValidateValues('invalid');
        return this.alertaMsj = {
          content: this.login.identificationType.mensaje,
          type: 'warning',
        };
      }
      this.sendValidateValues('valid', 'valid', 'valid');
      if (!this.login.password || !this.recovery.confirmPassword) {
        this.sendValidateValues('', '', '', '', 'invalid', 'invalid');
        return this.alertaMsj = {
          content: 'Coloque los campos requeridos',
          type: 'warning',
        };
      }
      if (this.login.password.length < 8) {
        this.sendValidateValues('', '', '', '', 'invalid', 'invalid');
        return this.alertaMsj = {
          content: 'La clave debe tener como mínimo 8 caracteres alfanuméricos',
          type: 'warning',
        };
      }
      if (this.login.password !== this.recovery.confirmPassword) {
        this.sendValidateValues('', '', '', '', '', 'invalid');
        return this.alertaMsj = {
          content: 'Confirma tu contraseña',
          type: 'warning',
        };
      }
      this.sendValidateValues('', '', '', '', 'valid', 'valid');
      this.btnDisabled = true;
      this.$apollo.mutate({
        mutation: gql`${resetPasswordGql}`,
        variables: {
          identificationType: this.login.identificationType.value,
          identification: this.login.identification,
          password: this.login.password,
          code: this.recovery.code,
        },
      }).then((res) => {
        const msg = res.data.resetPassword.msg;
        switch (msg) {
          case 'success':
            this.alertaMsj = {
              content: 'Contraseña recuperada. Iniciando sesión',
              type: 'success',
            };
            this.$emit('sendLogin', this.login);
            break;
          case 'user_not_found':
            this.alertaMsj = {
              content: 'Usuario no existe!',
              type: 'danger',
            };
            break;
          case 'expired':
            this.alertaMsj = {
              content: 'La solicitud ha expirado',
              type: 'danger',
            };
            break;
          case 'failed':
            this.alertaMsj = {
              content: 'Hubo un fallo en el envío',
              type: 'danger',
            };
            break;
          default:
            this.alertaMsj = {
              content: 'Hubo algún error. Intenta más tarde.',
              type: 'danger',
            };
        }
        this.btnDisabled = false;
      }).catch((error) => {
        this.alertaMsj = {
          content: 'Hubo un error al enviar los datos.',
          type: 'danger',
        };
        this.btnDisabled = false;
      });
    },
    sendValidateValues(identification, identificationType, email,
        code, password, confirmPassword) {
      this.$emit('validateValue', {
        identification,
        identificationType,
        email,
        code,
        password,
        confirmPassword,
      });
    },
  },
};
</script>
<style lang="scss">
  .white-lines-form {
    i.prefix.active {
      color: $white-base !important;
    }
    input,
    select {
      border: 2px solid $white !important;
      color: $white !important;
    }
    select {
      background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px;
    }
    /* Estilos white-lines-form
      class-valid y class-invalid
    */
    .class {
      &-valid select.custom-select {
        background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px, url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e") transparent no-repeat center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem);
      }
      &-invalid select.custom-select {
        background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px,url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E") transparent no-repeat center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem);
      }
    }

    input + label,
    select + label {
      background-color: $primary-color-dark !important;
      color: $white !important;
      cursor: pointer !important;
      margin-left: 10px !important;
      padding: 0 5px !important;
      transition: all .5s ease;
    }
    select + label {
      transform: translateY(-13px) scale(0.8) !important;
    }
    input + label,
    select + label.label-inactive {
      font-weight: 300;
    }
    input + label.active {
      font-weight: 500 !important;
      left: 0 !important;
    }
    select + label.label-active {
      font-weight: 500 !important;
    }

    .outline-select .custom-select:focus + label.label-inactive,
    .outline-select .custom-select:focus + label.label-active,
    .prefix ~ label {
      margin-left: 46px !important;
    }
    .outline-date.md-form.md-outline {
      input[type*="date"] {
        & + label {
          transform: translate(1px,-10px) scale(0.8);
        }
      }
      & label.active {
        left: 0;
      }
    }
    .input-without-icon {
      @media screen and (min-width: 576px) {
        i {
          display: none !important
        }
        input {
          margin-left: auto !important;
          width: 100% !important;
        }
        label {
          margin-left: .5rem !important;
        }
      }
    }
    .with-icon {
      margin-left: 2rem;
      width: calc(100% - 2rem);
    }

    .our-checkbox2 label {
      span::before {
      color: $grey-lighten-2;
      }
      &:hover span::before {
        color: $white;
      }
    }
  }
</style>
